<template >
  <el-drawer
    custom-class="el-drawer-deal el-drawer-deal2"
    :visible.sync="ifshow"
    size="840px"
    v-if="ifshow"
    id="analyzeRight"
  >
    <div slot="title">
      <dealTitle :data="getByIdFullData" :statusShow="false"></dealTitle>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="举报信息处理" name="first">
        <commonReportInfo :data="getByIdFullData">
          <div slot="other">
            <el-form-item label="举报人：">{{getByIdFullData.creatuser}}</el-form-item>
            <el-form-item label="举报时间：">{{getByIdFullData.createtime|fullTime}}</el-form-item>
          </div>
        </commonReportInfo>
        <!-- 处理信息 -->
        <div>
          <div class="drawer-subtitle_common">
            <span>处理信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form label-width="100px">
              <el-form-item label="处理结果：">{{getByIdFullData.result}}</el-form-item>
              <el-form-item label="处理说明：">{{getByIdFullData.decisions}}</el-form-item>
              <el-form-item label="处理人：" v-show="loginType!=='SHOP'&&loginType!=='DEALER'">{{getByIdFullData.flowusername}}</el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="处理时间节点" name="second">
        <delFlowList></delFlowList>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>
<script>
import dealTitle from "@/views/CreditScore/common/dealMainInfo/dealTitle";
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import delFlowList from "views/CreditScore/common/delFlowList";
import { getLoginType } from "@/libs/until";

export default {
  data() {
    return {
      ifshow: false,
      activeName: "first",
      loginType:getLoginType()
    };
  },
  computed: {
    ...mapGetters(["getByIdFullData"])
  },
  components: { commonReportInfo, dealTitle,delFlowList }
};
</script>
<style lang="scss">
#analyzeRight {
  .el-drawer__header {
    margin-bottom: 0px !important;
  }
  .el-drawer .el-drawer__body {
    background-color: #f0f2f5;
  }
}
</style>
